<template>
  <div>
    <Header />
    <div class="container max-app-width">
      <ProgressBar />
      <router-view />
      <ReviewCard class="d-md-none d-lg-none d-xl-none"/>
    </div>
    <Footer />
  </div>
</template>

<script>
  import debounce from 'lodash/debounce';
  import { mapActions, mapGetters } from 'vuex';

  import Footer from './global/Footer';
  import Header from './global/Header';
  import ProgressBar from './common/ProgressBar';
  import ReviewCard from './common/cards/ReviewCard';
  import { RG_DIRECT_MAIL, RATEGENIUS_NEW_APPLICATION } from '../values/sponsor';

  export default {
    components: {
      Footer,
      Header,
      ProgressBar,
      ReviewCard
    },

    computed: {
      ...mapGetters({
        brandName: 'brand/name',
        brandFavicon: 'brand/favicon',
        brandStylesheet: 'brand/stylesheet',
        displayMode: 'global/displayMode',
        sponsorId: 'trackingData/sponsorId'
      })
    },

    metaInfo () {
      const title = (this.brandName || '').includes('AUTOPAY')
        ? this.brandName
        : `AUTOPAY | ${this.brandName}`;

      return {
        link: [
          { rel: 'shortcut icon', href: this.brandFavicon }
        ],
        style: [
          { cssText: this.brandStylesheet, type: 'text/css' }
        ],
        title
      };
    },

    mounted () {
      if (!SVGElement.prototype.contains) {
        SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
      }
      const defaultPage = document.querySelector('#default');
      defaultPage.parentNode.removeChild(defaultPage);
      window.dataLayer.push({
        event: 'workFlow',
        workFlow: this.$di.workflowService.activeFlow
      });
      this.scrollToTop();
      this.$nextTick(function () {
        window.addEventListener('resize', this.onResize);
        this.onResize();
      });
      if (this.sponsorId === RG_DIRECT_MAIL || this.sponsorId === RATEGENIUS_NEW_APPLICATION) {
        this.$di.promoCodeService.hydrateFromLocalStorage();
      }
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.onResize);
    },

    methods: {
      ...mapActions({
        setWindowWidth: 'global/setWindowWidth',
        scrollToTop: 'global/scrollToTop'
      }),
      onResize: debounce(function () {
        this.setWindowWidth(window.innerWidth);
      }, 1000, { leading: false, trailing: true })
    }
  };
</script>

<style lang="scss" scoped>
  .max-app-width {
    max-width: 850px;
  }
</style>
